<template>
 <header class="header acr-bold-22">
   <el-dialog
     :show-close="false"
     :visible.sync="confirmServiceStatusSwitchModal"
     width="750px">
     <template slot="title">
       <div class="modal-title acr-bold-22">
         <div>
           <div class="modal-btn" @click="confirmServiceStatusSwitchModal = false">
             <svgicon name="Chevron-left"></svgicon>
           </div>
           <span style="margin-top: -1px">Are you sure want to turn service {{serviceIsActive ? 'OFF' : 'ON'}}?</span>
         </div>
         <div class="modal-btn active" @click="serviceIsActive = !serviceIsActive;confirmServiceStatusSwitchModal = false">
           <svgicon name="Arrow-right"></svgicon>
         </div>
       </div>
     </template>
   </el-dialog>

   <div class="header-logo" @click="$router.push('/dashboard')">
     <img src="../../assets/logo/LogoWithDarkText.svg" alt="">
   </div>
   <div class="header-search" :class="{'focused': !!search}" @keydown.enter="confirmSearchQuery">
     <svgicon name="Search"></svgicon>
     <vue-autosuggest
       v-model="search"
       @selected="search = $event.item"
       @blur="searchInFocus = false"
       @focus="searchInFocus = true"
       :suggestions="search.length > 0 ? [{data: suggestions}] : []"
       :input-props="{id:'autosuggest__input', placeholder:'Search', class: 'input input-header acr-bold-18', maxlength: '35'}"
     >
       <template slot-scope="{suggestion}">
         <span class="acr-medium">{{suggestion.item}}</span>
       </template>
     </vue-autosuggest>
     <transition name="fade">
       <div class="header-search__filters" :class="{'focused': !!search}">
         <div class="header-search__filter acr-medium"
              @click="activeSearchType = filter"
              :key="filter" v-for="filter in searchTypes" :class="{'active': activeSearchType === filter}">
             <span style="margin-top: -2px">
               {{filter}}
             </span>
         </div>
         <svgicon name="Close" @click="search = ''"></svgicon>
         <div class="header-search__confirm" :class="{'active': !!search}" @click="confirmSearchQuery" v-loading="loading">
           <svgicon name="Arrow-right" :class="{'hidden': loading}"></svgicon>
         </div>
       </div>
     </transition>
     <transition name="fade">

     </transition>
   </div>
   <div style="width: 22%"></div>
   <div class="header-profile">
     <transition name="fade">
       <!--<div class="header-nav" v-if="!search && !searchInFocus">-->
       <div class="header-nav">
         <div class="header-nav-item"
              :class="{'active' : $route.name === item.name || (item.name === 'projects' && $route.meta.highlightProject) || (item.name === 'dashboard' && $route.meta.highlightFiles)}"
              @click="navigate(item.name)"
              v-for="(item, index) in menuItems" :key="index.path">
           {{ item.meta.title.charAt(0).toUpperCase() + item.meta.title.slice(1)}}
         </div>
         <!--<div class="header-nav-item">-->
         <!--Dashboard-->
         <!--</div>-->
       </div>
     </transition>
     <div class="header-avatar" :class="{'active': serviceIsActive}" ref="avatar">
       <img src="../../assets/img/Portrait_Placeholder.png" @click="showLogout = !showLogout">
       <span class="header-service-status" :class="{'active': serviceIsActive}" @click="confirmServiceStatusSwitchModal = true">
         <svgicon name="CloudSlash" v-if="!serviceIsActive"></svgicon>
         <svgicon name="CloudCheck" v-else></svgicon>
       </span>
       <div class="header-logout" v-closable="{
            exclude: ['avatar'],
            handler: 'clickOutside'
          }" :class="{'opened': showLogout, 'with-persons': projectTypes.includes('video_analytics')}">
         <div class="header-logout__profile">
           <img src="../../assets/img/Portrait_Placeholder.png" class="header-logout__avatar">
           <div>
             <div class="header-logout__name acr-bold">Admin</div>
             <div class="header-logout__email acr-regular">admin@acronis.com</div>
           </div>
         </div>
         <div class="header-logout__btn" @click="$router.push('/persons');showLogout=false" v-if="projectTypes.includes('video_analytics')">
           <!--<svgicon name="SignIn"></svgicon>-->
           <span class="acr-bold" style="margin-top: -2px">Persons</span>
         </div>
         <div class="header-logout__btn" @click="logoutClickHandler">
           <svgicon name="SignIn"></svgicon>
           <span class="acr-bold" style="margin-top: -2px">Log out</span>
         </div>
       </div>
     </div>
   </div>
 </header>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import { getServiceStatus, startService, stopService } from "../../api/services";
  import { search, fetchSuggestions } from '../../api/search';
  import { VueAutosuggest } from 'vue-autosuggest';

  export default {
    name: 'Header',
    components: { VueAutosuggest },
    data(){
      return {
        isShowSettingsDialog: false,
        confirmServiceStatusSwitchModal: false,
        serviceIsActive: false,
        showLogout: false,
        search: '',
        timeout: null,
        searchInFocus: false,
        loading: false,
        searchTypes: [
          'all',
          'videos',
          'projects',
          'detections',
        ],
        activeSearchType: 'all',
        suggestions: []
      }
    },
    watch: {
      activeSearchType(v) {
        if (this.$route.name === 'search-results') {
          search(this.search, v).then(res => {
            this.$store.commit('setSearchResults', res.data);
          });
        }
      },
      serviceIsActive(v) {
        if (v) {
          startService();
        } else {
          stopService();
        }
      },
      search(v) {
        this.$store.commit('setSearchQuery', v);
        if (this.timeout)
          clearTimeout(this.timeout);


        fetchSuggestions(v).then(res => {
          this.suggestions = res.data.suggestions.slice(0, 10);
        });

        if (!v) {
          this.$store.commit('setSearchResults', []);
          if (this.$route.name === 'search-results') this.$router.push('/dashboard');
        }
      },
      searchQuery(v) {
        if (!v) {
          this.search = '';
          this.$refs['searchInput'].blur();
          this.$refs['searchInput'].value = '';

          if (this.$route.name === 'search-results') this.$router.push('/dashboard');
        }
      }
    },
    created() {
      getServiceStatus().then((res) => this.serviceIsActive = res.data);
    },
    computed: {
      ...mapGetters({
        searchQuery: 'searchQuery',
        projectTypes: 'projectTypes',
      }),
      menuItems() {
        return this.$router.getRoutes().filter((item) => !item.meta.dontShowInMenu);
      },
    },
    methods: {
      ...mapActions({
        logout: 'logout'
      }),
      clickOutside() {
        if (this.showLogout) this.showLogout = false
      },
      logoutClickHandler() {
        this.logout()
      },
      navigate(index) {
        this.$router.push({ name: index });
      },
      confirmSearchQuery() {
        this.loading = true;
        if (this.search) {
          search(this.search, this.activeSearchType).then(res => {
            this.$store.commit('setSearchResults', res.data);
            this.$router.push('/search-results');
            this.loading = false;
          });
        }
      },
    }
  };
</script>
<style scoped lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
  }


  li:hover {
    cursor: pointer;
  }

  /deep/
  .el-loading-mask {
    background-color: transparent;
    .el-loading-spinner {
      margin-top: -17px;
    }
    svg {
      width: 15px;
      height: 15px;
      margin-top: 2px;
      circle {
        stroke: white;
        stroke-width: 6px;

      }
    }
  }
</style>
